// extracted by mini-css-extract-plugin
module.exports = {"paddedColumn":"login-page_paddedColumn__35MAk"};